import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getRegisterResultReviews } from 'apis/registerResult.api';

const useGetRegisterResultReviews = (id, conds = {}) => {
  const { data: _data, ...rest } = useQuery(
    ['registerResultReviews', id, conds],
    () => getRegisterResultReviews(id),
    {
      ...conds,
    }
  );

  const data = useMemo(() => _data?.data ?? [], [_data]);

  return { data, ...rest };
};

export default useGetRegisterResultReviews;
